import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/contractorgroup";



class ContractorGroupService {

  editgroup(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addgroup(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
  groupExist(name:string, id : number){
    return axios
      .post(API_URL + '/exist', {name: name, id : id})
      .then(response => {
        return response.data;
      });
  }

  deletegroup(groupId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+groupId)
      .then(response => {
        return response.data;
      });
  }

  


  getgroups(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


  getLookups() {
    return axios
      .get(API_URL + "/lookups" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }
 

}

export default new ContractorGroupService();